import { z } from "zod";

const schema = z.object({
  count: z.number().int().min(1),
});

type Schema = z.infer<typeof schema>;

export {
  schema as adminGenerateMatchesFormSchema,
  type Schema as AdminGenerateMatchesFormSchema,
};
